import { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { Notyf } from "notyf";
import { useNavigate, Link } from "react-router-dom";

function Register() {
  const notyf = new Notyf();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNo: "",
    password: "",
    confirmPassword: "",
  });

  const [isButtonActive, setIsButtonActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    if (
      formData.firstName === "" ||
      formData.lastName === "" ||
      formData.email === "" ||
      formData.mobileNo === "" ||
      formData.password === "" ||
      formData.confirmPassword === ""
    ) {
      setIsButtonActive(false);
    } else if (formData.password !== formData.confirmPassword) {
      setIsButtonActive(false);
    } else {
      setIsButtonActive(true);
    }
  }, [formData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here, such as validation and API calls
    console.log("Form submitted:", formData);
    // FETCH API call here to register the user
    fetch(`${process.env.REACT_APP_API_BASE_URL}/users/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          notyf.error("Registration failed. Please try again.");
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("User registered successfully:", data);
        // Reset form after submission
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobileNo: "",
          password: "",
          confirmPassword: "",
        });
        notyf.success("Registration successful!");
        navigate("/login");
      })
      .catch((error) => {
        console.error("Error registering user:", error);
        notyf.error("An error occurred while registering.");
      });
  };

  return (
    <div className="auth-page-wrapper">
      {/* Auth Hero Section */}
      <div className="auth-hero-section">
        <Container>
          <div className="text-center py-5">
            <div className="auth-icon-container mx-auto mb-4">
              <i className="fas fa-user-plus text-white"></i>
            </div>
            <h1 className="display-4 fw-bold text-white mb-3">
              Join FreshMart!
            </h1>
            <p className="lead text-white-50 mb-4">
              Create your account and start your fresh shopping journey
            </p>
            <div className="hero-divider mx-auto"></div>
          </div>
        </Container>
      </div>

      {/* Register Form Section */}
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8} xl={6}>
            <Card className="register-card border-0 shadow-lg">
              <Card.Body className="p-5">
                <div className="text-center mb-4">
                  <div className="form-icon-container mx-auto mb-3">
                    <i className="fas fa-user-edit"></i>
                  </div>
                  <h3 className="fw-bold text-dark mb-2">Create Account</h3>
                  <p className="text-muted">
                    Fill in your details to get started
                  </p>
                </div>

                <Form onSubmit={handleSubmit}>
                  {/* Name Fields Row */}
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-semibold text-dark mb-2">
                          <i className="fas fa-user me-2 text-success"></i>
                          First Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          placeholder="Enter your first name"
                          className="modern-input"
                          style={{
                            borderRadius: "12px",
                            border: "2px solid #e9ecef",
                            padding: "12px 16px",
                            fontSize: "1rem",
                            transition: "all 0.3s ease",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-semibold text-dark mb-2">
                          <i className="fas fa-user me-2 text-success"></i>
                          Last Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          placeholder="Enter your last name"
                          className="modern-input"
                          style={{
                            borderRadius: "12px",
                            border: "2px solid #e9ecef",
                            padding: "12px 16px",
                            fontSize: "1rem",
                            transition: "all 0.3s ease",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Contact Fields Row */}
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-semibold text-dark mb-2">
                          <i className="fas fa-envelope me-2 text-success"></i>
                          Email Address
                        </Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter your email"
                          className="modern-input"
                          style={{
                            borderRadius: "12px",
                            border: "2px solid #e9ecef",
                            padding: "12px 16px",
                            fontSize: "1rem",
                            transition: "all 0.3s ease",
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-semibold text-dark mb-2">
                          <i className="fas fa-phone me-2 text-success"></i>
                          Mobile Number
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="mobileNo"
                          value={formData.mobileNo}
                          onChange={handleChange}
                          placeholder="Enter your mobile number"
                          className="modern-input"
                          style={{
                            borderRadius: "12px",
                            border: "2px solid #e9ecef",
                            padding: "12px 16px",
                            fontSize: "1rem",
                            transition: "all 0.3s ease",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Password Fields Row */}
                  <Row className="mb-4">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-semibold text-dark mb-2">
                          <i className="fas fa-lock me-2 text-success"></i>
                          Password
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          placeholder="Create a password"
                          className="modern-input"
                          style={{
                            borderRadius: "12px",
                            border: "2px solid #e9ecef",
                            padding: "12px 16px",
                            fontSize: "1rem",
                            transition: "all 0.3s ease",
                          }}
                        />
                        <Form.Text className="text-muted">
                          Password must be at least 6 characters long
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-semibold text-dark mb-2">
                          <i className="fas fa-lock me-2 text-success"></i>
                          Confirm Password
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          placeholder="Confirm your password"
                          className={`modern-input ${
                            !passwordMatch && formData.confirmPassword
                              ? "border-danger"
                              : ""
                          }`}
                          style={{
                            borderRadius: "12px",
                            border: `2px solid ${
                              !passwordMatch && formData.confirmPassword
                                ? "#dc3545"
                                : "#e9ecef"
                            }`,
                            padding: "12px 16px",
                            fontSize: "1rem",
                            transition: "all 0.3s ease",
                          }}
                        />
                        {!passwordMatch && formData.confirmPassword && (
                          <Form.Text className="text-danger">
                            Passwords do not match
                          </Form.Text>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Terms and Conditions */}
                  <div className="mb-4">
                    <Form.Check
                      type="checkbox"
                      label={
                        <span className="text-muted">
                          I agree to the{" "}
                          <Link to="#" className="text-success">
                            Terms of Service
                          </Link>{" "}
                          and{" "}
                          <Link to="#" className="text-success">
                            Privacy Policy
                          </Link>
                        </span>
                      }
                      required
                    />
                  </div>

                  <div className="d-grid mb-4">
                    <Button
                      type="submit"
                      disabled={!isButtonActive || isLoading}
                      className="register-btn fw-bold py-3"
                      style={{
                        borderRadius: "12px",
                        fontSize: "1.1rem",
                        background: isButtonActive
                          ? "linear-gradient(135deg, #28a745 0%, #20c997 100%)"
                          : "#6c757d",
                        border: "none",
                        boxShadow: isButtonActive
                          ? "0 8px 25px rgba(40, 167, 69, 0.3)"
                          : "none",
                        transition: "all 0.3s ease",
                      }}
                    >
                      {isLoading ? (
                        <>
                          <i className="fas fa-spinner fa-spin me-2"></i>
                          Creating Account...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-user-plus me-2"></i>
                          Create Account
                        </>
                      )}
                    </Button>
                  </div>

                  <div className="text-center">
                    <p className="text-muted mb-0">
                      Already have an account?{" "}
                      <Link
                        to="/login"
                        className="text-success fw-semibold text-decoration-none"
                      >
                        Sign In
                      </Link>
                    </p>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Enhanced Custom Styles */}
      <style jsx>{`
        .auth-page-wrapper {
          min-height: 100vh;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .auth-hero-section {
          background: linear-gradient(135deg, #6f42c1 0%, #495057 100%);
          position: relative;
          overflow: hidden;
        }

        .auth-hero-section::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="registerPattern" width="25" height="25" patternUnits="userSpaceOnUse"><circle cx="12.5" cy="12.5" r="1" fill="white" opacity="0.1"/><circle cx="6" cy="19" r="0.5" fill="white" opacity="0.15"/><circle cx="19" cy="6" r="0.5" fill="white" opacity="0.15"/></pattern></defs><rect width="100" height="100" fill="url(%23registerPattern)"/></svg>');
          pointer-events: none;
        }

        .auth-icon-container {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          width: 100px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(10px);
        }

        .auth-icon-container i {
          font-size: 3rem;
        }

        .hero-divider {
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, transparent, white, transparent);
          border-radius: 2px;
        }

        .register-card {
          border-radius: 25px !important;
          overflow: hidden;
          backdrop-filter: blur(10px);
        }

        .form-icon-container {
          background: linear-gradient(135deg, #6f42c1 0%, #495057 100%);
          border-radius: 50%;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .form-icon-container i {
          font-size: 1.8rem;
          color: white;
        }

        .modern-input:focus {
          border-color: #28a745 !important;
          box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
          transform: translateY(-1px);
        }

        .modern-input:hover {
          border-color: #20c997;
        }

        .modern-input.border-danger:focus {
          border-color: #dc3545 !important;
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
        }

        .register-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 12px 35px rgba(40, 167, 69, 0.4) !important;
          background: linear-gradient(
            135deg,
            #218838 0%,
            #1e7e34 100%
          ) !important;
        }

        .register-btn:disabled {
          cursor: not-allowed;
          opacity: 0.7;
        }

        @media (max-width: 768px) {
          .auth-hero-section .display-4 {
            font-size: 2.5rem;
          }

          .auth-hero-section .py-5 {
            padding: 3rem 0 !important;
          }

          .auth-icon-container {
            width: 80px;
            height: 80px;
          }

          .auth-icon-container i {
            font-size: 2.5rem;
          }

          .register-card .p-5 {
            padding: 2rem !important;
          }
        }
      `}</style>
    </div>
  );
}

export default Register;
